/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 24,
    height: 15,
    viewBox: '0 0 24 15',
    data: '<path pid="0" d="M1.365 8.849h17.977l-3.931 3.866a1.321 1.321 0 000 1.892 1.376 1.376 0 001.924 0l6.266-6.16a1.321 1.321 0 000-1.893L17.335.393a1.376 1.376 0 00-1.924 0 1.321 1.321 0 000 1.892l3.931 3.88H1.365C.615 6.164 0 6.767 0 7.506c0 .738.614 1.342 1.365 1.342z" _fill="#000" fill-rule="nonzero"/>'
  }
})
